<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <!-- logo -->
    <div class="logo">
      <img
        v-if="bannerArr.length > 0"
        :src="$imgUrl + bannerArr[0].thumb"
        alt=""
      />
    </div>
    <div class="container">
      <div class="ex_list" v-loading="loading" v-if="list.length > 0">
        <div
          class="ex_item"
          v-for="(item, index) in list"
          :key="index"
          @click="tapnewsDetail(item)"
        >
          <img :src="item.url" />
        </div>
      </div>
      <div class="nodata_box" v-else>
        <nodata></nodata>
      </div>
      <div class="ex_footer">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :page-size="search.page_size"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>
  
  <script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import nodata from "../../components/nodata.vue";
import { getBanner, getFileList } from "@/api/api";
export default {
  components: { top, bottom, nodata },
  name: "newsList",
  // 配置title和meta数据
  metaInfo() {
    return {
      title: "BCEIA-新闻列表",
      meta: [
        {
          name: "description",
          content: "新闻列表新闻列表新闻列表",
        },
      ],
    };
  },
  data() {
    return {
      search: {
        page_no: 1,
        page_size: 12,
      },
      langSet: "",
      bannerArr: [],
      list: [],
      total: 0,
      loading: false,
      id: "",
    };
  },
  created() {},
  mounted() {
    this.id = this.$route.query.id;
    this.langSet = localStorage.getItem("languageSet") || "cn";
    this.getBannerList();
    this.getFileList();
  },
  methods: {
    // zhang 获取新闻列表banner
    getBannerList() {
      let data = {
        class: "新闻列表",
        lang_type: this.langSet,
      };
      getBanner(data)
        .then((res) => {
          if (res.code == 1) {
            this.bannerArr = res.data.lists;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // zhang 获取最新动态数据
    getFileList() {
      this.loading = true;
      let data = { ...this.search, cid: this.id };
      getFileList(data)
        .then((res) => {
          if (res.code == 1) {
            console.log(res, "res");
            this.list = res.data.lists;
            this.total = Number(res.data.count);
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

    // 切换分页
    handleCurrentChange(val) {
      this.search.page_no = val;
      this.getFileList();
    },
    // zhang 进去展商详情
    gotoDetail(item) {
      this.$router.push({
        path: "/exhibitorDetail",
        query: {
          company_long_id: item.company_long_id,
        },
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.nodata_box {
  margin: 100px 0 50px;
}
.logo {
  width: 100%;
  height: 400px;
  img {
    width: 100%;
    height: 400px;
  }
}
.custom_btn {
  width: 120px;
  height: 50px;
  border-radius: 12px;
  border: 1px solid #243889;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
}
.search_btn {
  background: #243889;
  border-radius: 12px;
  color: #ffffff;
  margin: 0 20px;
}
.reset_btn {
  background: #f7f8fa;
  color: #2c2c2e;
}
.container {
  background: #fff;
  // width: 1280px;
  margin: 80px auto;
  .ex_footer {
    background: #fff;
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 50px;
  }
  .search_box {
    display: flex;
    .custom_sel {
      position: relative;
      margin-right: 20px;
      .sel::placeholder {
        color: #000 !important;
      }
    }
  }
  .ex_tips {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    margin: 20px 0 10px;
  }
  .ex_list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .ex_item {
      width: -webkit-calc((100% - 21px * 4)/ 4);
      width: calc((100% - 21px * 4) / 4);
      // padding: 15px;
      box-sizing: border-box;
      background: #fff;
      margin: 0 21px 50px 0;
      img {
        width: 100%;
        height: 185px;
      }
      .news_title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 22px;
        color: #2c2c2e;
        line-height: 30px;
        margin: 15px 0;
      }
      .news_time {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #3a3a3c;
      }
    }
  }
  .ex_list::after {
    content: "";
    flex: auto;
  }
  .search_value {
    width: 815px;
    height: 50px;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #dddddd;
    padding-left: 55px;
    box-sizing: border-box;
  }
  .search_value::placeholder {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #999999;
  }
}
@media only screen and (max-width: 1280px) {
  .ex_item {
    width: -webkit-calc((100% - 21px * 3)/ 3) !important;
    width: calc((100% - 21px * 3) / 3) !important;
    margin: 0 21px 50px 0 !important;
  }
}
@media only screen and (max-width: 1000px) {
  .ex_item {
    width: -webkit-calc((100% - 21px * 2)/ 2) !important;
    width: calc((100% - 21px * 2) / 2) !important;
    margin: 0 21px 50px 0 !important;
  }
}
@media only screen and (max-width: 767px) {
  .logo {
    width: 100%;
    height: 81px !important;
    margin-top: 0.88rem;
    img {
      width: 100%;
      height: 81px !important;
    }
  }
  .container .ex_list .ex_item {
    width: 100% !important;
    margin-bottom: 20px !important;
  }
}
</style>
  <style>
.exhibitorList_box .el-select {
  width: 165px;
  height: 50px;
}
.exhibitorList_box .el-select .el-input__inner {
  height: 50px;
  background: #f7f8fa;
  border-radius: 12px;
  border: none;
}
.exhibitorList_box .el-select > .el-input {
  height: 50px;
}
.exhibitorList_box .el-select .el-input .el-select__caret {
  color: #000;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #243889;
  border-radius: 4px;
  border: 1px solid #243889;
}
</style>